<app-qa-check-list scrollHeight="540px"
  [fields]="fields"
  [form]="qualityAssuranceForm"
  [disabled]="disabled"
  [signatureConfig]="signatureConfig"
></app-qa-check-list>